export const KLEAR_ACCOUNT_TYPE_RECEIVABLE = 'receivable' as const
export const KLEAR_ACCOUNT_TYPE_PAYABLE = 'payable' as const
export const KLEAR_ACCOUNT_TYPE_OPERATIONAL = 'operational' as const

export const KLEAR_ACCOUNT_TYPES = [
  KLEAR_ACCOUNT_TYPE_RECEIVABLE,
  KLEAR_ACCOUNT_TYPE_PAYABLE,
  KLEAR_ACCOUNT_TYPE_OPERATIONAL
] as const

export type KlearAccountType = (typeof KLEAR_ACCOUNT_TYPES)[number]

export const KLEAR_ACCOUNT_TYPES_ADMIN_CREATE = [KLEAR_ACCOUNT_TYPE_PAYABLE, KLEAR_ACCOUNT_TYPE_OPERATIONAL] as const

export const KLEAR_ACCOUNT_TYPE_LABELS: Record<KlearAccountType, string> = {
  [KLEAR_ACCOUNT_TYPE_RECEIVABLE]: 'Receivable Account',
  [KLEAR_ACCOUNT_TYPE_PAYABLE]: 'Payable Account',
  [KLEAR_ACCOUNT_TYPE_OPERATIONAL]: 'Operational Account'
}

export function klearAccountTypeLabel(accountType: KlearAccountType): string {
  return KLEAR_ACCOUNT_TYPE_LABELS[accountType]
}
